import { render, staticRenderFns } from "./SelectCustomerTax.vue?vue&type=template&id=a6b25ac0&"
import script from "./SelectCustomerTax.vue?vue&type=script&lang=ts&"
export * from "./SelectCustomerTax.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6b25ac0')) {
      api.createRecord('a6b25ac0', component.options)
    } else {
      api.reload('a6b25ac0', component.options)
    }
    module.hot.accept("./SelectCustomerTax.vue?vue&type=template&id=a6b25ac0&", function () {
      api.rerender('a6b25ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InvoiceAr/SelectCustomerTax.vue"
export default component.exports